module.exports = __webpack_public_path__ + "assets/letter-green.a4f44ed5.svg";